// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`17.1|151.37000|167.9|159.28500|000.0|H|N|CZU Local Net
17.2|154.32500|000.0|153.77000|162.2|H|N|Santa Cruz County Dispatch
17.3|154.19000|103.5|156.00000|162.2|H|N|Santa Cruz County Command
17.4|154.41500|151.4|154.41500|151.4|L|N|Santa Cruz County Tactical
17.5|154.44500|162.2|154.44500|162.2|L|N|Santa Cruz County Tactical
17.6|154.05500|192.8|154.05500|192.8|L|N|Santa Cruz County Tactical
17.7|150.77500|192.8|150.77500|192.8|L|N|Santa Cruz County Tactical
17.8|151.04000|151.4|151.04000|151.4|L|N|Santa Cruz County Tactical
17.9|154.13000|141.3|156.22500|141.3|H|N|UCSC Tac
17.10|153.83750|167.9|153.83750|167.9|L|N|Santa Cruz County Fire Tac
17.11|154.28000|156.7|154.28000|156.7|H|N|National Interoperability Fire
17.12|154.26500|156.7|154.26500|156.7|L|N|National Interoperability Fire
17.13|154.29500|156.7|154.29500|156.7|L|N|National Interoperability Fire
17.14|154.27250|156.7|154.27250|156.7|L|N|National Interoperability Fire
17.15|154.28750|156.7|154.28750|156.7|L|N|National Interoperability Fire
17.16|154.30250|156.7|154.30250|156.7|L|N|National Interoperability Fire
17.17|151.13750|136.5|159.47250|136.5|L|N|National Interoperability Fire
17.18|156.07500|156.7|156.07500|156.7|H|N|
17.19|151.17500|192.8|151.17500|192.8|L|N|
17.20|151.19000|192.8|151.19000|192.8|L|N|
17.21|151.32500|192.8|151.32500|192.8|L|N|
17.22|151.34000|192.8|151.34000|192.8|L|N|
17.23|151.22000|192.8|151.22000|192.8|L|N|
17.24|159.26250|192.8|159.26250|192.8|L|N|
17.25|159.36750|192.8|159.36750|192.8|L|N|CDF AIR TO GND NET
17.26|151.35500|103.5|159.30000|000.0|H|N|
17.27|151.26500|103.5|159.33000|000.0|H|N|
17.28|151.40000|103.5|159.37500|000.0|H|N|
17.29|153.89000|114.8|159.07500|107.2|H|N|San Mateo County
17.30|154.34000|114.8|159.07500|107.2|H|N|San Mateo County
17.31|154.14500|114.8|159.07500|107.2|H|N|San Mateo County
17.32|154.23500|114.8|159.07500|107.2|H|N|San Mateo County
17.33|151.08500|114.8|159.07500|107.2|H|N|San Mateo County
17.34|154.37000|114.8|156.01500|123.0|H|N|San Mateo Command 11
17.35|154.04000|118.8|154.04000|118.8|L|N|San Mateo Tactical
17.36|154.01000|110.9|154.01000|110.9|L|N|San Mateo Tactical
17.37|155.40000|141.3|155.40000|141.3|L|N|San Mateo Tactical
17.38|153.78500|156.7|158.85000|156.7|H|N|San Mateo County
17.39|153.95000|114.8|156.04500|114.8|H|N|San Mateo Command 21
17.40|154.14500|118.8|154.14500|118.8|L|N|San Mateo Tactical
17.41|153.83000|110.9|153.83000|110.9|L|N|San Mateo Tactical
17.42|155.74500|162.2|155.74500|162.2|L|N|San Mateo Tactical
17.43|154.10000|114.8|160.06500|114.8|H|N|San Mateo County
17.44|151.08500|123.0|158.79000|123.0|H|N|San Mateo Command 21
17.45|154.01000|118.8|154.01000|118.8|L|N|San Mateo Tactical
17.46|154.04000|162.2|154.04000|162.2|L|N|San Mateo Tactical
17.47|155.40000|107.2|155.40000|107.2|L|N|San Mateo Tactical
17.48|155.89500|114.8|160.17000|162.2|H|N|San Mateo Command 41
17.49|153.83000|141.3|153.83000|141.3|L|N|San Mateo Tactical
17.50|154.44500|146.2|154.44500|146.2|L|N|San Mateo Tactical
17.51|155.74500|123.0|155.74500|123.0|L|N|San Mateo Tactical
17.52|151.47500|167.9|159.01500|167.9|H|N|San Mateo Command 51
17.53|154.25000|162.2|158.35500|162.2|H|N|Santa Clara Co-Central Fire
17.54|155.98500|179.9|158.95500|167.9|H|N|Santa Clara Co Wide CMD
17.55|154.17500|162.2|154.17500|162.2|L|N|Santa Clara Co - Central Fire
17.56|154.20500|179.9|154.20500|179.9|L|N|Santa Clara Co - Central Fire
17.57|154.14500|192.8|154.14500|192.8|L|N|Santa Clara Co - Central Fire
17.58|154.40000|110.9|154.40000|110.9|L|N|Santa Clara Co - Central Fire
17.59|153.90500|192.8|153.90500|192.8|L|N|Santa Clara Co - Central Fire
17.60|153.77000|110.9|154.44500|110.9|H|N|PALO ALTO CITY
17.61|154.05500|110.9|156.06000|110.9|H|N|PALO ALTO CITY
17.62|156.80000|000.0|156.80000|000.0|L|W|Coast AIRGUARD 16
17.63|157.05000|000.0|157.05000|000.0|L|W|Coast AIRGUARD 21 (Tactical)
17.64|157.10000|000.0|157.10000|000.0|L|W|Coast AIRGUARD 22 (Tactical)
17.65|157.15000|000.0|157.15000|000.0|L|W|Coast AIRGUARD 23 (Tactical)
17.66|156.42500|000.0|156.42500|000.0|L|W|Coast AIRGUARD 68
17.67|156.72500|000.0|156.72500|000.0|L|W|Coast AIRGUARD 74
17.68|153.75500|000.0|154.98000|000.0|H|N|
17.69|168.76250|167.9|162.90000|167.9|H|N|SF City Mutual Aid
17.70|164.80000|000.0|164.10000|000.0|H|N|
17.71|169.72500|000.0|165.45000|OST|H|N|Tone 1 Frmnt/Tone 6 Wildcat
17.72|168.30000|CSQ|168.30000|OST|H|N|BLM Scene of Action
17.73|154.92000|156.7|154.92000|156.7|H|N|CALAW1 with CTCSS 156.7
17.74|154.92000|000.0|154.92000||H|N|CALAW1 without Tones
17.75|155.56500|000.0|N/A|N/A|N/A|N|
17.76|154.95000|000.0|N/A|N/A|N/A|N|
17.77|154.38500|88.5|N/A|N/A|H|N|N Santa Cruz Coast
17.78|156.03000|186.2|N/A|N/A|N/A|N|
17.79|155.05500|000.0|N/A|N/A|N/A|N|
17.80|155.08500|000.0|N/A|N/A|N/A|N|
17.81|155.94000|000.0|N/A|N/A|N/A|N|
17.82|155.62500|162.2|N/A|N/A|N/A|N|
17.83|154.84500|000.0|N/A|N/A|N/A|N|
17.84|156.21000|179.9|N/A|N/A|N/A|N|
17.85|158.77500|000.0|N/A|N/A|N/A|N|
17.86|159.09000|000.0|N/A|N/A|N/A|N|
17.87|155.4750|156.7|N/A|N/A|N/A|N|
17.88|154.77000|162.2|N/A|N/A|N/A|N|
17.89|155.16000|000.0|155.16000|127.3|L|N|
17.90|155.23500|151.4|N/A|N/A|N/A|N|
17.91|156.09000|91.5|N/A|N/A|N/A|N|
17.92|152.09000|146.2|N/A|N/A|N/A|N|Dispatch for LE
17.93|151.23500|203.5|N/A|N/A|N/A|N|Secondary
17.94|150.77500|203.5|N/A|N/A|N/A|N|Tactical
17.95|151.23500|123.0|N/A|N/A|N/A|N|Admin
17.96|168.62500|000.0|168.62500|110.9|L|N|Emergency
18.1|168.05000|000.0|168.05000|000.0|L|N|
18.2|168.20000|000.0|168.20000|000.0|L|N|
18.3|168.60000|000.0|168.60000|000.0|L|N|
18.4|166.72500|000.0|166.72500|000.0|L|N|
18.5|166.77500|000.0|166.77500|000.0|L|N|
18.6|168.25000|000.0|168.25000|000.0|L|N|
18.7|166.55000|000.0|166.55000|000.0|L|N|
18.8|167.11250|000.0|167.11250|000.0|L|N|
18.9|168.23750|000.0|168.23750|000.0|L|N|
18.10|168.66250|000.0|168.66250|000.0|L|N|
18.11|163.10000|000.0|163.10000|000.0|L|N|
18.12|166.67500|000.0|166.67500|000.0|L|N|
18.13|167.95000|000.0|167.95000|000.0|L|N|
18.14|168.35000|000.0|168.35000|000.0|L|N|
18.15|169.15000|000.0|169.15000|000.0|L|N|
18.16|169.20000|000.0|169.20000|000.0|L|N|
18.17|170.00000|000.0|170.00000|000.0|L|N|
18.18|170.97500|000.0|168.70000|000.0|L|N|
18.19|170.45000|000.0|168.10000|000.0|L|N|
18.20|170.42500|000.0|168.07500|000.0|L|N|
18.21|170.00000|000.0|166.67500|000.0|L|N|
18.22|169.75000|000.0|167.10000|000.0|L|N|
18.23|168.47500|000.0|165.40000|000.0|L|N|
18.24|169.53750|000.0|164.71250|000.0|L|N|
18.25|170.01250|000.0|165.25000|000.0|L|N|
18.26|170.41250|000.0|165.96250|000.0|L|N|
18.27|170.68750|000.0|166.57500|000.0|L|N|
18.28|173.03750|000.0|167.32500|000.0|L|N|
18.29|172.37500|000.0|164.93750|000.0|H|N|USFS Angeles NF Forest Net
18.30|173.77500|000.0|164.87500|000.0|H|N|Angeles NF Admin Net
18.31|171.50000|000.0|164.82500|000.0|H|N|Angeles NF Service Net
18.32|171.47500|000.0|168.15000|000.0|H|N|San Bernardino NF Forest Net
18.33|172.22500|000.0|164.13750|000.0|H|N|San Bernd NF Admin Net
18.34|171.42500|103.5|164.80000|000.0|H|N|USFS Cleveland NF Forest Net
18.35|171.13750|000.0|164.50000|000.0|H|N|Cleveland NF ADMN 2017
18.36|172.40000|000.0|164.12500|000.0|H|N|CNF NF Service Net
18.37|171.52500|156.7|162.75000|000.0|H|N|USFS El Dorado NF Forest Net
18.38|172.32500|000.0|165.22500|000.0|H|N|Eldorado NF Admin Net
18.39|173.76250|000.0|164.82500|000.0|H|N|Eldorado NF Service Net
18.40|170.52500|000.0|164.18750|000.0|H|N|(Toiyabe) Bridgeport ranger dist
18.41|173.80000|000.0|165.01250|000.0|H|N|USFS Inyo NF NORTH
18.42|173.83750|000.0|166.26250|000.0|H|N|USFS Inyo NF SOUTH
18.43|172.40000|000.0|164.12500|000.0|H|N|INF S NF Service Net
18.44|171.52500|000.0|165.41250|000.0|H|N|USFS Klamath NF
18.45|169.63750|000.0|168.77500|000.0|H|N|Klamath Black Net
18.46|172.27500|000.0|164.70000|000.0|H|N|Klamath Orange Net
18.47|172.40000|000.0|164.12500|000.0|H|N|Klamath Salmon Net
18.48|172.32500|000.0|162.22500|000.0|H|N|Klamath Saget Net
18.49|172.25000|000.0|165.07500|000.0|H|N|Klamath River Net
18.50|173.18750|000.0|164.80000|000.0|H|N|USFS Lassen NF FIRE Net
18.51|171.47500|000.0|164.91250|000.0|H|N|Lassen NF Admin Net
18.52|169.95000|000.0|164.10000|000.0|H|N|Lassen NF Service Net
18.53|170.46250|000.0|164.91250|000.0|H|N|Los Padres NF Forest Net
18.54|171.55000|000.0|164.15000|000.0|H|N|USFS LP Admin Net
18.55|171.50000|000.0|164.82500|000.0|H|N|LP Serv net
18.56|170.73750|000.0|164.98750|000.0|H|N|USFS Modoc NF Forest Net
18.57|173.78750|000.0|162.48750|000.0|H|N|MDF Admin Net
18.58|169.95000|000.0|164.10000|000.0|H|N|MDF Service Net
18.59|171.55000|000.0|164.50000|000.0|H|N|USFS Mendocino NF FIRE Net
18.60|169.97500|000.0|169.17500|000.0|H|N|Mendocino Admin Net
18.61|172.40000|000.0|164.12500|000.0|H|N|Mendocino Service Net
18.62|170.55000|000.0|164.87500|000.0|H|N|USFS Plumas NF FIRE Net
18.63|171.42500|000.0|163.16250|000.0|H|N|Plumas ADMIN Net
18.64|171.50000|000.0|164.82500|000.0|H|N|Plumas Service Net
18.65|171.57500|000.0|165.01250|000.0|H|N|USFS Shasta-Trinity NF Forest
18.66|171.50000|000.0|164.82500|000.0|H|N|Shasta-Trinity Service Net
18.67|167.22500|000.0|167.22500|000.0|H|N|USFS SHF Management Unit
18.68|168.96250|000.0|168.96250|000.0|H|N|USFS SHF Management Unit
18.69|166.98750|000.0|166.98750|000.0|H|N|USFS SHF Management Unit
18.70|167.72500|000.0|167.72500|000.0|H|N|USFS SHF Management Unit
18.71|172.22500|000.0|164.78750|000.0|H|N|USFS Sierra NF
18.72|171.47500|000.0|163.68750|000.0|H|N|Sierral NF Admin Net 17
18.73|169.90000|000.0|165.70000|000.0|H|N|Sequoia NF Emer Net
18.74|170.55000|000.0|166.00000|000.0|H|N|USFS Sequoia NF
18.75|172.40000|000.0|164.12500|000.0|H|N|Sequoia NF Service Net
18.76|168.96250|000.0|168.96250|000.0|H|N|Sequoia NF Admin Net
18.77|172.37500|000.0|164.17500|000.0|H|N|USFS Six Rivers NF
18.78|170.47500|000.0|165.75000|000.0|H|N|Six Rivers Admin Net
18.79|169.95000|000.0|164.78750|000.0|H|N|Six Rivers Service Net
18.80|170.50000|000.0|168.75000|000.0|H|N|USFS Stanislaus NF
18.81|171.13750|000.0|168.15000|000.0|H|N|Stanisl NF Admin Net 17
18.82|172.37500|156.7|164.96250|000.0|H|N|USFS TMU Basin 1
18.83|171.57500|156.7|165.41250|000.0|H|N|Lake Tahoe Basin Mang Unit
18.84|170.60000|000.0|164.93750|000.0|H|N|USFS Tahoe NF Fire Net
18.85|169.90000|000.0|168.77500|000.0|H|N|FS TNF Forest Net
18.86|172.40000|000.0|164.12500|000.0|H|N|Tahoe Service Net
18.87|168.30000|000.0|168.30000|000.0|H|N|BLM SCENE OF ACTION
18.88|169.40000|000.0|169.40000|000.0|H|N|BLM SOA New in 2017
18.89|172.61250|000.0|166.37500|000.0|H|N|BLM ADMIN NET North West
18.90|171.62500|000.0|164.25000|000.0|H|N|BLM FIRE North East
18.91|169.77500|000.0|163.02500|000.0|H|N|BLM FIRE Bakersfield
18.92|166.48750|000.0|167.07500|000.0|H|N|BLM FIRE NET South
18.93|172.58750|000.0|164.67500|000.0|H|N|BLM FIRE Motherload
18.94|162.40000|000.0|000.00000|000.0||W|Nat. Weather Service RX only
18.95|162.42500|000.0|000.00000|000.0||W|Nat. Weather Service RX only
18.96|162.45000|000.0|000.00000|000.0||W|Nat. Weather Service RX only
18.97|162.50000|000.0|000.00000|000.0||W|Nat. Weather Service RX only
18.98|162.52500|000.0|000.00000|000.0||W|Nat. Weather Service RX only
18.99|162.55000|000.0|000.00000|000.0||W|Nat. Weather Service RX only
18.100|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
